import { render, staticRenderFns } from "./SO_report.vue?vue&type=template&id=1f51b09c&"
import script from "./SO_report.vue?vue&type=script&lang=js&"
export * from "./SO_report.vue?vue&type=script&lang=js&"
import style0 from "./SO_report.vue?vue&type=style&index=0&id=1f51b09c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports